module.exports = __webpack_public_path__ + "static/img/after_two.b27e480.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/after_two.png
// module id = r+rw
// module chunks = 1